/**
 * CouncilResult — final synthesised decision view (position + rationale
 * + dissents + next actions + collapsible full transcript).
 */
import React from 'react';
import { Check } from 'lucide-react';

export default function CouncilResult({ result, personas }) {
  if (!result) return null;
  const moderatorName = personas.find((p) => p.id === result.moderator)?.english_name;
  return (
    <div className="mt-4 ve-card p-5" data-testid="council-result">
      <div className="ve-eyebrow text-[#5E1F8B]">Decision · synthesised by {moderatorName}</div>
      <h2 className="display text-2xl font-bold mt-2">{result.synthesis?.position || 'No position synthesised.'}</h2>

      {result.synthesis?.rationale && (
        <ul className="mt-4 space-y-2">
          {result.synthesis.rationale.map((r, i) => (
            <li key={`r-${i}-${String(r).slice(0, 24)}`} className="text-sm flex gap-2"><span className="text-[#5E1F8B]">·</span><span>{r}</span></li>
          ))}
        </ul>
      )}

      {result.synthesis?.dissents?.length > 0 && (
        <div className="mt-5">
          <div className="ve-eyebrow text-rose-600">Dissents</div>
          <div className="mt-2 space-y-2">
            {result.synthesis.dissents.map((d, i) => (
              <div key={`d-${i}-${d.persona}`} className="rounded-md bg-rose-50 border border-rose-200 p-3 text-sm">
                <b>{personas.find((p) => p.id === d.persona)?.english_name || d.persona}:</b> {d.objection}
              </div>
            ))}
          </div>
        </div>
      )}

      {result.synthesis?.next_actions?.length > 0 && (
        <div className="mt-5">
          <div className="ve-eyebrow text-[#5E1F8B]">Next actions</div>
          <ul className="mt-2 space-y-1.5">
            {result.synthesis.next_actions.map((a, i) => (
              <li key={`a-${i}-${String(a).slice(0, 24)}`} className="text-sm flex gap-2"><Check size={14} className="text-emerald-600 mt-0.5 shrink-0"/><span>{a}</span></li>
            ))}
          </ul>
        </div>
      )}

      <details className="mt-6 cursor-pointer">
        <summary className="text-xs uppercase tracking-[0.22em] font-bold text-slate-500 hover:text-[#5E1F8B]">
          View full council transcript
        </summary>
        <div className="mt-3 space-y-3">
          {result.answers?.map((a) => (
            <div key={a.persona} className="rounded-md border border-slate-200 p-3">
              <div className="text-xs uppercase tracking-[0.18em] font-bold text-[#5E1F8B] mb-1">
                {personas.find((p) => p.id === a.persona)?.english_name || a.persona}
              </div>
              <p className="text-sm text-slate-700 whitespace-pre-wrap">{a.answer}</p>
            </div>
          ))}
        </div>
      </details>
    </div>
  );
}
